module.exports = __webpack_public_path__ + "img/copypaste.8eac5108.png";